module.exports = __webpack_public_path__ + "img/bmi.ac28959a.png";